import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import NAV from "../nav";
import { sleep } from "../../utils";

const RightSideDrawer = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const lockClick = () => {
    /* Dialog.confirm({
      content: "Do you want to lock?",
      confirmText: "Yes",
      cancelText: "No",
      onConfirm: async () => {
        await sleep(2000);
        context.logout(true);

        //window.location.reload(true);
      },
    });*/
    setShow(true);
  };

  const lockConfirm = async () => {
    await sleep(1000);
    context.logout();
    context.updateMobileUserId("");
    context.updateMobilePassword("");
  };
  const actionClick = (actionName) => {
    if (actionName == "logout") lockClick();
  };

  const DrawerList = (
    <Box
      sx={{ width: 300 }}
      role="presentation"
      onClick={(e) => props.onHide && props.onHide()}
    >
      <List>
        {NAV.map((item, i) => {
          return item.title == "divider" ? (
            <Divider />
          ) : (
            context.allowedAccess(item.module, item.action) &&
              (item.onclick ? (
                <ListItem
                  key={i}
                  disablePadding
                  onClick={(e) => actionClick(item.onclick)}
                >
                  <ListItemButton>
                    <ListItemIcon>
                      <item.muiIcon />
                    </ListItemIcon>
                    <ListItemText primary={item.title} />
                  </ListItemButton>
                </ListItem>
              ) : (
                <Link to={item.path} className="text-dark">
                  <ListItem key={i} disablePadding>
                    <ListItemButton>
                      <ListItemIcon>
                        <item.muiIcon />
                      </ListItemIcon>
                      <ListItemText primary={item.title} />
                    </ListItemButton>
                  </ListItem>
                </Link>
              ))
          );
        })}
      </List>
    </Box>
  );

  return (
    <>
      <Drawer
        open={props.visible || false}
        onClose={(e) => props.onHide && props.onHide()}
      >
        {DrawerList}
      </Drawer>

      <Dialog
        open={show}
        onClose={(e) => setShow(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/*<DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle>*/}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Do you want to Logout ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setShow(false)}>Cancel</Button>
          <Button onClick={(e) => lockConfirm()} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default RightSideDrawer;
